import React from "react";
import CircularHeaderLoader from "./CircularHeaderLoader";
const ObjectiveCard = (props) => {
  const {rankings, campaign, objective, className} = props;

  const getPosition = (rankings, objective) => {
    const prod = objective.abbr.split("|")[1]
    const rank = rankings.find(r => r.ranking_type === "objectives" && r.name.indexOf(prod) > -1)
    if (!rank) return ""
    return `${rank.position}º Lugar`
  } 

  const normalizedPercentage = Number(objective.percentage);
  const normalizedExperctedPercentage = Number(
    objective.expected_percentage,
  );
  const totalPercentage =
    normalizedPercentage > 100 ? 100 : normalizedPercentage;
  return (
    <div className={`objectives-card ${className}`}>
      <CircularHeaderLoader
        campaign={campaign}
        progress={totalPercentage}
        expected_progress={normalizedExperctedPercentage}
        id={objective.id}
      >
        <span className="objectives-card-percentage">
          {normalizedPercentage.toFixed(0)}
          <div className="sign">%</div> 
        </span>
      </CircularHeaderLoader>
      <div className="objectives-card-content">
        <div className="objectives-card-title">{objective.abbr}</div>
        <div className="objectives-card-position">{getPosition(rankings, objective)}</div>
      </div>

    </div>
  );
};

const ObjectivesCards = ({ client, rankings,objectives, campaign, color, containerClassName, cardClassName }) => {
  if (objectives.length === 0) {
    return <></>;
  }
  return (
    <div className={`objectives-cards-container ${containerClassName}`}>
      {objectives.map((o) => (
        <ObjectiveCard
          className={cardClassName}
          rankings={rankings}
          objective={o}
          campaign={campaign}
          key={"high-obj-" + o.id}
        />
      ))}
    </div>
  );
};

export default ObjectivesCards;
